(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

document.addEventListener("click", function (e) {
                  if (!e.target.closest(".swatch-link")) return; // Ensure it's a swatch click
                
                  e.preventDefault();
                
                  const swatchLink = e.target.closest(".swatch-link");
                  let productUrl = swatchLink.getAttribute("href").split("?")[0]; // Remove search query
                  const productId = swatchLink.getAttribute("data-product-id");
                  const productCard = document.querySelector(`.product-block[data-product-id="${productId}"]`);
                
                  if (!productCard) {
                    console.error("Product card not found for ID:", productId);
                    return;
                  }
                
                  console.log("Fetching product data for:", productId);
                
                  // Abort previous fetch requests if they exist (to prevent multiple updates)
                  if (window.activeFetchRequest) {
                    window.activeFetchRequest.abort();
                  }
                
                  const controller = new AbortController();
                  window.activeFetchRequest = controller;
                
                  fetch(productUrl + ".js", { signal: controller.signal })
                    .then((response) => response.json())
                    .then((data) => {
                      console.log("Fetched product data:", data);

                
                      // Update product title
                      const titleElement = productCard.querySelector(".product-block__title");
                      if (titleElement) {
                        titleElement.innerText = data.title;
                      }
                
                      // Get image containers
                      const productImageContainerActive = productCard.querySelector(".product-block__image.product-block__image--primary.product-block__image--active .img-ar.img-ar--cover");
                      const productImageContainerHover = productCard.querySelector(".product-block__image[data-image-index='1'] .img-ar.img-ar--cover");
                      const dataImageIndexContainer = productCard.querySelector(".product-block__image[data-image-index='2'] .img-ar.img-ar--cover");
                      // const dataImageIndexContainer = productCard.querySelector('[data-image-index="2"]');

//                       const getOptimizedImage = (url, width = 300) => {
//   const parts = url.split('.');
//   if (parts.length > 1) {
//     parts[parts.length - 2] += `_${width}x`;
//   }
//   return parts.join('.');
// };

                      function getOptimizedImage(url, width) {

                        console.log(url)
                        
                        if (!url || !width) return url;
                      
                        // Extract the file extension
                        const lastDotIndex = url.lastIndexOf('.');
                        if (lastDotIndex === -1) return url; // Invalid URL without extension
                      
                        const prefix = url.substring(0, lastDotIndex);
                        const extension = url.substring(lastDotIndex);
                      
                        // Add width suffix before extension
                        const newUrl = `${prefix}_${width}x${extension}`;
                        return newUrl;
                      }
                
                      if (data.images.length > 0) {
                        const firstImage = getOptimizedImage(data.images[0], 500);// + `?v=${Date.now()}`; // Prevent caching
                        const secondImage = getOptimizedImage(data.images[1], 500);// ? data.images[1] + `?v=${Date.now()}` : firstImage; // Fallback to first image if no second
                        const thirdImage = getOptimizedImage(data.images[2], 500);
                
                        console.log("Updating images:", { firstImage, secondImage, thirdImage });
                
                        // Clear existing images **before** adding new ones
                        if (productImageContainerActive) productImageContainerActive.innerHTML = "";
                        if (productImageContainerHover) productImageContainerHover.innerHTML = "";
                        if (dataImageIndexContainer) dataImageIndexContainer.innerHTML = ""; // Clear previous swatch image
                
                        // Add new images
                        if (productImageContainerActive) {
                          const activeImg = document.createElement("img");
                          activeImg.src = firstImage;
                          console.log('First Image Changed')
                          activeImg.alt = data.title;
                          activeImg.classList.add("product-image");
                          productImageContainerActive.appendChild(activeImg);
                          // productImageContainerActive.innerHTML = "";
                          // productImageContainerActive.insertAdjacentHTML('beforeend', `<img src="${firstImage}" alt="${data.title}" class="product-image">`)
                        }
                
                        if (productImageContainerHover) {
                          const hoverImg = document.createElement("img");
                          hoverImg.src = secondImage;
                          console.log('Second Image Changed')
                          hoverImg.alt = data.title;
                          hoverImg.classList.add("product-image");
                          productImageContainerHover.appendChild(hoverImg);
                          // productImageContainerHover.innerHTML = "";
                          // productImageContainerHover.insertAdjacentHTML('beforeend', `<img src="${secondImage}" alt="${data.title}" class="product-image">`)
                        }
                
                        if (dataImageIndexContainer) {
                          const swatchImg = document.createElement("img");
                          swatchImg.src = thirdImage; // Use first image
                          console.log('Third Image Changed')
                          swatchImg.alt = data.title;
                          swatchImg.classList.add("product-image");
                          dataImageIndexContainer.appendChild(swatchImg);
                          // dataImageIndexContainer.innerHTML = "";
                          // dataImageIndexContainer.insertAdjacentHTML('beforeend', `<img src="${thirdImage}" alt="${data.title}" class="product-image">`)
                        }
                      }
                
                      // Update product links
                      const productLink = productCard.querySelector(".product-link");
                      if (productLink) {
                        productLink.href = data.url;
                      }
                
                      const productLink2 = productCard.querySelector(".titleLink");
                      if (productLink2) {
                        productLink2.href = data.url;
                      }
                
                      // Update selected swatch class
                      productCard.querySelectorAll(".variant-group li").forEach((li) => li.classList.remove("selected"));
                      swatchLink.closest("li").classList.add("selected");
                
                      // Update the form to use the selected product's variant
                      const form = productCard.querySelector('form[action="/cart/add"]');
                      if (form && data.variants.length > 0) {
                        form.querySelector('[name="id"]').value = data.variants[0].id;
                      }
                    })
                    .catch((error) => {
                      if (error.name === "AbortError") {
                        console.warn("Previous fetch request aborted for:", productId);
                      } else {
                        console.error("Error fetching product data:", error);
                      }
                    });
                });

  } catch(e) { console.error(e); }
})();
})();
